export const autoHideDurationDefault = 5000;

export const autoHideDurationSuccess = 2000;

export const autoHideDurationInfo = 3000;